import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getR1InvoiceInfoPartnerTypes = (): Promise<ISelectModel<string>[]> =>
  API.get('/api/accommodation/calculations/r1-invoice-info/partner-types')?.then(res => res?.data);
